/** Shared print / PDF-adjacent invoice layout styles (A4, print-safe). */
const GRID_BORDER = '#374151';

export const INVOICE_PRINT_CSS = `
@page { size: A4 portrait; margin: 12mm; }
*{box-sizing:border-box;}
html,body{width:100%;margin:0;padding:0;background:#fff;}
body{font-family:'Segoe UI',Arial,Helvetica,sans-serif;color:#0B1F3A;font-size:13px;}
table{width:100%;border-collapse:collapse;}
.inv-print{width:100%;max-width:100%;margin:0;color:#0B1F3A;border:2px solid #0B2545;border-radius:8px;padding:16px 20px;background:#fff;}
.inv-print-top{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;margin-bottom:18px;}
.inv-print-brand{display:flex;align-items:center;gap:14px;min-width:0;}
.inv-print-logo{width:68px;height:68px;object-fit:contain;border-radius:50%;border:2px solid #E5E4DF;padding:5px;background:#fff;}
.inv-print-brand-name{font-size:24px;font-weight:800;color:#0B2545;letter-spacing:-0.3px;}
.inv-print-company{text-align:right;font-size:13px;line-height:1.6;color:#374151;max-width:380px;}
.inv-print-company-name{font-size:16px;font-weight:700;color:#0B2545;margin-bottom:6px;}
.inv-print-title-row{display:flex;align-items:center;gap:16px;margin:22px 0 14px;}
.inv-print-line{flex:1;height:2px;background:#D1D5DB;}
.inv-print-title{font-size:22px;font-weight:800;color:#0B2545;letter-spacing:3px;}
.inv-print-invno{text-align:right;font-size:14px;color:#374151;margin-bottom:16px;}
.inv-print-invno strong{font-size:17px;color:#0B2545;}
.inv-print-grid{display:grid;grid-template-columns:1fr 1fr;gap:0;margin-bottom:16px;border:1px solid ${GRID_BORDER};}
.inv-print-box{padding:14px 16px;border:none;border-right:1px solid ${GRID_BORDER};border-radius:0;background:#FAFAF8;min-height:96px;}
.inv-print-box:last-child{border-right:none;}
.inv-print-lbl{font-size:11px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px;}
.inv-print-box .inv-print-bill-name{font-size:16px;font-weight:700;margin-bottom:4px;color:#0B2545;}
.inv-print-box .inv-print-bill-sub{font-size:14px;line-height:1.55;}
.inv-print-box .inv-print-bill-meta{font-size:12px;color:#6B7280;margin-top:6px;}
.inv-print-box .inv-print-pay{font-size:14px;line-height:1.75;}
.inv-print-meta{margin-bottom:16px;}
.inv-print-meta th,.inv-print-meta td{border:1px solid ${GRID_BORDER};padding:12px 14px;font-size:14px;}
.inv-print-meta th{background:#0B2545;color:#fff;text-align:left;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;width:50%;}
.inv-print-meta td{font-weight:600;}
.inv-print-items{margin-bottom:16px;}
.inv-print-items th,.inv-print-items td{border:1px solid ${GRID_BORDER};padding:10px 12px;vertical-align:top;font-size:13px;}
.inv-print-items th{background:#0B2545;color:#fff;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:.8px;font-weight:700;}
.inv-print-items tbody td{background:#fff;}
.inv-print-items tfoot td{font-size:14px;vertical-align:middle;background:#fff;}
.inv-print-tot-label{font-weight:600;color:#374151;text-align:left;}
.inv-print-tot-amt{text-align:right;font-weight:700;color:#0B2545;}
.inv-print-items tfoot tr.inv-print-tot-total td{background:#0B2545;color:#fff;font-size:16px;font-weight:800;border-color:${GRID_BORDER};}
.inv-print-items tfoot tr.inv-print-tot-total .inv-print-tot-label{color:#fff;}
.inv-print-items tfoot tr.inv-print-tot-total .inv-print-tot-amt{color:#C9A14A;}
.inv-print-items tfoot tr.inv-print-tot-paid .inv-print-tot-label,.inv-print-items tfoot tr.inv-print-tot-paid .inv-print-tot-amt{color:#16A34A;font-weight:700;font-size:14px;}
.inv-print-items tfoot tr.inv-print-tot-due td{background:#FEF2F2;border-color:${GRID_BORDER};}
.inv-print-items tfoot tr.inv-print-tot-due .inv-print-tot-label,.inv-print-items tfoot tr.inv-print-tot-due .inv-print-tot-amt{color:#B91C1C;font-weight:800;font-size:15px;}
.inv-print-items tfoot tr.inv-print-tot-ok td{background:#F0FDF4;border-color:${GRID_BORDER};}
.inv-print-items tfoot tr.inv-print-tot-ok .inv-print-tot-label,.inv-print-items tfoot tr.inv-print-tot-ok .inv-print-tot-amt{color:#0B2545;font-weight:800;font-size:15px;}
.inv-print-item-name{font-weight:700;font-size:14px;color:#0B2545;}
.inv-print-item-sub{font-size:12px;color:#6B7280;margin-top:3px;}
.inv-print-digital{margin-top:20px;padding:16px 18px;border:1px solid ${GRID_BORDER};border-radius:0;background:#EFF6FF;text-align:center;}
.inv-print-digital-badge{display:inline-block;font-size:15px;font-weight:800;color:#1D4ED8;letter-spacing:.3px;margin-bottom:6px;}
.inv-print-note{font-size:12px;color:#6B7280;line-height:1.65;}
.inv-print-alert{margin-top:16px;padding:14px 16px;background:#FFF8EC;border:1px solid ${GRID_BORDER};border-radius:0;font-size:13px;color:#92400E;}
@media print{
  html,body{width:210mm;height:297mm;}
  body{padding:0;}
  .inv-print{width:100%;max-width:none;border:2px solid #0B2545;border-radius:0;padding:14px 18px;-webkit-print-color-adjust:exact;print-color-adjust:exact;}
  .inv-print-meta th,.inv-print-items th,.inv-print-items tfoot tr.inv-print-tot-total td,.inv-print-digital{-webkit-print-color-adjust:exact;print-color-adjust:exact;}
}
`;

/** Native app invoice view — compact layout; injected after INVOICE_PRINT_CSS on iOS/Android only. */
export const INVOICE_PRINT_MOBILE_CSS = `
.inv-print{padding:8px 6px;border-width:1px;border-radius:4px;font-size:10px;}
.inv-print-top{display:flex;flex-direction:row;align-items:flex-start;justify-content:flex-start;gap:8px;margin-bottom:8px;}
.inv-print-brand{flex:0 0 54px;flex-direction:column;align-items:center;gap:2px;width:54px;max-width:54px;}
.inv-print-logo{width:34px;height:34px;padding:2px;border-width:1px;}
.inv-print-brand-name{font-size:8px;font-weight:700;line-height:1.1;text-align:center;word-break:break-word;}
.inv-print-company{flex:1;min-width:0;text-align:left;font-size:8px;line-height:1.35;max-width:none;}
.inv-print-company-name{font-size:10px;margin-bottom:2px;}
.inv-print-title-row{gap:5px;margin:8px 0 4px;}
.inv-print-title{font-size:11px;letter-spacing:1px;white-space:nowrap;}
.inv-print-line{height:1px;}
.inv-print-invno{text-align:center;font-size:9px;margin-bottom:8px;}
.inv-print-invno strong{font-size:10px;}
.inv-print-grid{grid-template-columns:1fr;margin-bottom:8px;}
.inv-print-box{padding:6px 8px;min-height:auto;border-right:none;border-bottom:1px solid ${GRID_BORDER};}
.inv-print-box:last-child{border-bottom:none;}
.inv-print-lbl{font-size:8px;margin-bottom:3px;letter-spacing:.4px;}
.inv-print-box .inv-print-bill-name{font-size:10px;}
.inv-print-box .inv-print-bill-sub{font-size:9px;}
.inv-print-box .inv-print-bill-meta{font-size:8px;margin-top:2px;}
.inv-print-box .inv-print-pay{font-size:9px;line-height:1.4;}
.inv-print-meta{margin-bottom:8px;}
.inv-print-meta th,.inv-print-meta td{padding:5px 6px;font-size:9px;}
.inv-print-meta th{font-size:8px;letter-spacing:.3px;}
.inv-print-items-wrap{overflow-x:visible;margin-bottom:8px;}
.inv-print-items{width:100%;min-width:0!important;table-layout:fixed;margin-bottom:8px;}
.inv-print-items th,.inv-print-items td{padding:3px 2px!important;font-size:8px!important;line-height:1.2;word-break:break-word;vertical-align:top;}
.inv-print-items th{font-size:7px!important;letter-spacing:0;}
.inv-print-items th:nth-child(1),.inv-print-items td:nth-child(1){width:5%!important;}
.inv-print-items th:nth-child(2),.inv-print-items td:nth-child(2){width:26%!important;}
.inv-print-items th:nth-child(3),.inv-print-items td:nth-child(3){width:11%!important;}
.inv-print-items th:nth-child(4),.inv-print-items td:nth-child(4){width:7%!important;}
.inv-print-items th:nth-child(5),.inv-print-items td:nth-child(5){width:12%!important;}
.inv-print-items th:nth-child(6),.inv-print-items td:nth-child(6){width:12%!important;}
.inv-print-items th:nth-child(7),.inv-print-items td:nth-child(7){width:9%!important;}
.inv-print-items th:nth-child(8),.inv-print-items td:nth-child(8){width:18%!important;}
.inv-print-item-name{font-size:9px!important;}
.inv-print-item-sub{font-size:7px!important;margin-top:1px;}
.inv-print-items tfoot td{font-size:8px!important;}
.inv-print-items tfoot tr.inv-print-tot-total td{font-size:9px!important;}
.inv-print-items tfoot tr.inv-print-tot-paid .inv-print-tot-label,.inv-print-items tfoot tr.inv-print-tot-paid .inv-print-tot-amt{font-size:8px!important;}
.inv-print-items tfoot tr.inv-print-tot-due .inv-print-tot-label,.inv-print-items tfoot tr.inv-print-tot-due .inv-print-tot-amt{font-size:9px!important;}
.inv-print-items tfoot tr.inv-print-tot-ok .inv-print-tot-label,.inv-print-items tfoot tr.inv-print-tot-ok .inv-print-tot-amt{font-size:9px!important;}
.inv-print-digital{margin-top:8px;padding:8px;}
.inv-print-digital-badge{font-size:10px;}
.inv-print-note{font-size:8px;line-height:1.4;}
.inv-print-alert{margin-top:8px;padding:8px;font-size:9px;}
`;

export function invoiceLogoSrc(org) {
  if (org?.logoUrl) return org.logoUrl;
  if (typeof window !== 'undefined') {
    const base = process.env.PUBLIC_URL || '';
    return `${window.location.origin}${base}/playstore.png`;
  }
  return '/playstore.png';
}

export const BRAND_DISPLAY_NAME = 'Foundersbridge';
